import React, { useEffect, useState } from 'react'
import { fetchFacturesStats } from '../../Services/dashboardService';

export default function StatFactureTable() {
    const [listannee, setlistannee] = useState([])
    const [statsData, setStatsData] = useState([]);

    const fetchCAData = async () => {
        const stats = await fetchFacturesStats();
        setStatsData(stats);
        const uniqueYears = [...new Set(stats.map(i => i.annee))];
        setlistannee(uniqueYears)
    };
    useEffect(() => {
        fetchCAData();
    }, []);

    return (
        <div className="card ">
                <div className="card-header  border-0">
                    <h4 className="card-title">Statistiques des Factures</h4>
                </div>
                <div className="card-body">

                <div className="table-responsive">


                            <table
                                className="table table-vcenter text-nowrap table-bordered border-bottom dataTable no-footer"
                                id="hr-table"
                                role="grid"
                                aria-describedby="hr-table_info"
                            >    <thead>
                                    <tr>
                                        <th className="p-3 border">Année</th>
                                        {['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'].map(mois => (
                                            <th colSpan={5} className="p-3 border"> {mois}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        {['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'].map(mois => (
                                            <React.Fragment key={mois}>
                                                <td className="p-3 border"> nb facture</td>
                                                <td className="p-3 border"> nb client FACTURé</td>
                                                <td className="p-3 border"> total ht</td>
                                                <td className="p-3 border"> total client</td>

                                                <td className="p-3 border"> new client</td>


                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    {listannee.map(a => (
                                        <tr key={a}>
                                            <td>{a}</td>
                                            {['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'].map(m => (
                                                <React.Fragment key={m}>
                                                    <td> {statsData.find(s => s.annee === a && s.mois === m)?.nombre_factures || 0}</td>
                                                    <td> {statsData.find(s => s.annee === a && s.mois === m)?.nombre_clients || 0}</td>
                                                    <td> {statsData.find(s => s.annee === a && s.mois === m)?.tt_net_a_payer_ht || 0}</td>
                                                    <td> {statsData.find(s => s.annee === a && s.mois === m)?.clientTT || 0}</td>
                                                    <td> {statsData.find(s => s.annee === a && s.mois === m)?.newclient || 0}</td>


                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                     
                    </div>
                </div>
            </div>
    )
}
